import {Carteira} from "../../carteira/carteira.model";
import {GrupoCarteira} from "../../grupo-carteira/grupo-carteira";

export class DadosCarteiraGrupoCarteiraModel {
    grupo: GrupoCarteira = null;
    carteiras: Carteira[] = [];
}
